import { Modal } from 'react-bootstrap';

const CustomsValueModal = ({ subTitle, animation, size, show, onHide, showButtons, onConfirm, header }) => {
  return (
    <Modal centered size={size} animation={animation} show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>{header}</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <span>{subTitle}</span>
      </Modal.Body>
      <Modal.Footer
        className="py-3 px-3"
        style={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <div className="push-left-right gap-4">
          <button
            className="blue-button-newload green"
            onClick={(event) => {
              onHide(event);
            }}
            style={{ display: showButtons ? 'flex' : 'none', borderRadius: '10px' }}
          >
            {' '}
            Cancel
          </button>

          <button
            className="blue-button-newload"
            onClick={(event) => {
              onConfirm();
              onHide(event);
            }}
            style={{ display: showButtons ? 'flex' : 'none', borderRadius: '10px' }}
          >
            Adjustments
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomsValueModal;
